export default{
    authurl:'https://laafiauthdev.azurewebsites.net/auth/api/'
}